export default __webpack_public_path__ + "static/media/IP-Sales.93cfe55f.svg";